import { cx } from 'class-variance-authority'
import React, { Children } from 'react'

type SliderProps = {
  children: JSX.Element[]
  additionnalClasses?: string
}

export const Slider = ({
  children,
  additionnalClasses = undefined,
}: SliderProps) => {
  if (!children) {
    return null
  }

  return (
    <ul
      className={cx(
        'flex md:h-full items-stretch py-1 no-scrollbar md:last:mr-1 md:first:ml-1',
        children.length > 1 && 'overflow-x-scroll space-x-1.5',
        additionnalClasses,
      )}
    >
      {Children.map(children, (child) => (
        <li className="h-full shrink-0">{child}</li>
      ))}
    </ul>
  )
}
